module.exports = __webpack_public_path__ + "media/images/countryrect/ml-7bd3941ad26f59f1f41c5fdecb921dd6.svg";